var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"f-modal container-fluid"},[_c('header',[_vm._t("header")],2),_vm._t("default"),_c('footer',{staticClass:"fixed-bottom"},[_vm._t("footer")],2)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }